import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import styles from './ProductImageSlider.module.scss';

// TODO: Remove JSDoc comments when migrating to TypeScript
/**
 *  @param {{id: string, images: {imageUrl: string, imageLabel: string}[], currentImageIndex: number}} props
 */
const ProductImageSlider = ({
  id = '',
  images = [],
  currentImageIndex = 0,
}) => (
  <>
    <HelmetProvider>
      <Helmet>
        {images?.map((image) => (
          <link
            key={image.imageLabel}
            rel='preload'
            href={image.imageUrl}
            as='image'
          />
        ))}
      </Helmet>
    </HelmetProvider>
    <div
      data-testid={`product-image-slider-id-${id}`}
      className={styles.wrapper}
    >
      <div className={styles.container}>
        <img
          src={images[currentImageIndex]?.imageUrl}
          alt={images[currentImageIndex]?.imageLabel}
        />
      </div>
    </div>
  </>
);

ProductImageSlider.propTypes = {
  id: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string,
      imageLabel: PropTypes.string,
    }),
  ),
  currentImageIndex: PropTypes.number,
};

export default ProductImageSlider;
